(() => {
  'use strict';
  if (customElements.get('pdparts-wheel-addons')) return;
  class WheelAddons extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.scope = this.closest('[data-product-section]');
      this.requestLink = this.querySelector('[data-addon-request]');
      this.controls = this.querySelector('[data-addon-controls]');
      if (!this.scope || !this.requestLink || !this.controls) return;
      this.links ||= new WeakMap();
      this.onChange = () => this.update();
      this.onClick = event => {
        const link = event.target.closest('a[data-wheel-enquiry]');
        if (link && this.scope.contains(link)) this.updateLink(link);
      };
      this.scope.addEventListener('change', this.onChange);
      this.scope.addEventListener('click', this.onClick, true);
      this.ready = true;
      this.update();
      this.controls.hidden = false;
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
      this.scope?.removeEventListener('click', this.onClick, true);
      this.ready = false;
    }
    selection() {
      const tyre = this.querySelector('[data-addon-tyres]:checked');
      const mounting = this.querySelector('[data-addon-mounting]')?.checked;
      return `${this.dataset.tyreLabel}: ${tyre?.dataset.quoteLabel || ''}; ${this.dataset.mountingLabel}: ${mounting ? this.dataset.mountingYes : this.dataset.mountingNo}`;
    }
    updateLink(link) {
      const previous = this.links.get(link);
      const base = !previous || link.href !== previous.result ? link.href : previous.base;
      const url = new URL(base, location.href);
      const contact = new URL(this.requestLink.href, location.href);
      if (url.origin !== location.origin || url.pathname !== contact.pathname || !url.searchParams.has('product')) return;
      let title = url.searchParams.get('product');
      if (link === this.requestLink) {
        const option = this.scope.querySelector('[data-variant-select]')?.selectedOptions[0];
        if (option && this.dataset.hasVariants === 'true' && title.startsWith(this.dataset.baseTitle)) {
          title = this.dataset.productTitle + ' – ' + option.dataset.variantTitle + title.slice(this.dataset.baseTitle.length);
        }
      }
      const details = ['Bil', 'Årgang', 'Karrosseri', 'Lystype', 'Udstyr', 'Tagtype', 'Side']
        .map(label => title.indexOf(` | ${label}: `, this.dataset.productTitle.length))
        .filter(index => index >= 0);
      const split = details.length ? Math.min(...details) : title.length;
      url.searchParams.set('product', `${title.slice(0, split)} | ${this.dataset.requestLabel}: ${this.selection()}${title.slice(split)}`);
      link.href = url.pathname + url.search + url.hash;
      this.links.set(link, {base, result: link.href});
    }
    update() {
      this.scope.querySelectorAll('a[data-wheel-enquiry]').forEach(link => this.updateLink(link));
      this.querySelector('[data-addon-summary]').textContent = this.selection();
    }
  }
  customElements.define('pdparts-wheel-addons', WheelAddons);
})();
